import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { ProfileContext } from 'providers/profile'
import { ModalContentContainer } from '../style'

const EmailConfirmationModal = () => {
  const { profile } = useContext(ProfileContext)

  return (
    <ModalContentContainer>
      <FormattedMessage id={'changeEmailConfirmation'} values={{email: `${profile.email}`}} />
    </ModalContentContainer>

  )
}

export default EmailConfirmationModal
